import { message } from 'antd';
import { FC, useCallback, useEffect } from 'react';
import { useCareNoteContext } from '../../../../contexts/CareNoteContext/CareNoteContext';
import { usePatientContext } from '../../../../contexts/PatientInfoContext/PatientInfoContext';
import useBoolean from '../../../../hooks/useBoolean/useBoolean';
import { CareNote, useCareNoteInsert } from '../../../../uc-api-sdk';
import { CareNoteFormComponent } from '../../component/CareNoteFormComponent/CareNoteFormComponent/CareNoteFormComponent';

import { useMixpanelContext } from '../../../../contexts/MixpanelContext/MixpanelContext';
import { MixpanelEvents, MixpanelEventsParents } from '../../../../contexts/MixpanelContext/MixpanelEvents';
import { useMpTrackingHelper } from '../../../../hooks/useMpTrackingHelper/useMpTrackingHelper';
import { BillableTimeInterventionComponentEnum, BillableTimeInterventionDetailEnum } from '../../../billableTime/contants/contants';
import { useBillableTimeInterventionComp } from '../../../billableTime/hook/useBillableEventTracker/useBillableTimeInterventionComp';
import { CareNoteTexts } from './constant';

export interface CreateCareNoteFormContainerProps {
  onSubmit?: () => void;
  onCancel?: () => void;
}

export const CreateCareNoteFormContainer: FC<CreateCareNoteFormContainerProps> = ({
  onSubmit,
  onCancel,
}) => {
  const { value: isLoading, setTrue, setFalse } = useBoolean(false);
  const { info } = usePatientContext();
  const { id = '' } = info?.patientInfo || {};
  const useInsert = useCareNoteInsert({});
  const { refresh } = useCareNoteContext();
  const { send } = useBillableTimeInterventionComp();
  const { send: sendMixpanel } = useMixpanelContext();
  const { startEvent, endEvent } = useMpTrackingHelper({
    eventStart: MixpanelEvents.AddCareNoteStart,
    eventEnd: MixpanelEvents.AddCareNoteEnd,
    patientId: id,
    parent: MixpanelEventsParents.CareNotesTab,
  });

  useEffect(() => {
    startEvent();
  }, []);

  const insertCareNote = useCallback(async (values: CareNote) => {
    setTrue();
    sendMixpanel({ event: MixpanelEvents.AddCareNote, patientId: id });
    send({
      patientId: id as string,
      component: BillableTimeInterventionComponentEnum.AddCareNote,
      detail: BillableTimeInterventionDetailEnum.AddCareNoteSubmit,
    });
    const response = await useInsert.send({
      params: {
        document: { ...values, memberId: id },
      },
    });

    if (response?.code === 200) {
      message.success(CareNoteTexts.createSuccess);
    } else if (response?.code && response.code >= 400) {
      message.warning(CareNoteTexts.error);
    }
    endEvent();
    setFalse();
    onSubmit?.();
    refresh?.();
  }, []);

  return (
    <CareNoteFormComponent
      isLoading={isLoading}
      onSubmit={insertCareNote}
      onCancel={onCancel}
    />
  );
};
